import { Box, Flex } from 'rebass'
import styled from '@emotion/styled'

import { CSSTransition } from 'react-transition-group'

import Thumb, { THUMB_SIZE } from '../../../components/Thumb'
import { bouncyCss } from './ComputerChoseStyles'

const Title = styled('div')`
  color: white;
  text-transform: uppercase;
  font-size: 20px;
`

const ThumbHolder = ({ title, children }) => (
  <Flex flexDirection="column" alignItems="center">
    <Title>{title}</Title>
    {children}
  </Flex>
)

const ComputerChoseDesktop = ({ userChose, computerChose }) => {
  return (
    <>
      <ThumbHolder title="You Picked">
        <Box mt={6}>
          <Thumb thumbSize={THUMB_SIZE.MEDIUM} thumbType={userChose} hasWon={false} />
        </Box>
      </ThumbHolder>
      <ThumbHolder title="The House Picked">
        <Box mt={6} css={bouncyCss}>
          <CSSTransition in={computerChose !== ''} classNames="bouncy" timeout={1000}>
            <Thumb
              key="computerChose"
              thumbSize={THUMB_SIZE.MEDIUM}
              thumbType={computerChose}
              hasWon={false}
            />
          </CSSTransition>
        </Box>
      </ThumbHolder>
    </>
  )
}

export default ComputerChoseDesktop
